module.exports = __webpack_public_path__ + "static/media/charles_darwin.c1ce3b12.png";